module.exports = __webpack_public_path__ + "img/tu01.b5a187ef.png";